import { Button } from '../atoms/Button';
import { Label } from '../atoms/Label';
import Modal from './Modal';

interface DataErrorModalProps {
  isOpen: boolean;
  onClose: () => void;
  heading: string;
  message?: string;
  children?: React.ReactNode;
}

const DataErrorModal = ({
  heading,
  children,
  isOpen,
  onClose,
  message,
}: DataErrorModalProps) => {
  return (
    <Modal isOpen={isOpen} onClose={onClose}>
      <div className="flex flex-col items-center justify-center rounded-lg bg-white p-6 shadow-lg">
        <Label titleType="largeHeader" className="mb-4">
          {heading}
        </Label>

        {children && children}

        {message !== undefined && (
          <div className="flex flex-col items-center justify-center p-4">
            <h2 className="text-lg font-bold text-red-600">Data Error</h2>
            <p className="mt-2 text-sm text-ink">
              {message ||
                'An error occurred while fetching the data. Please try again later.'}
            </p>
          </div>
        )}

        <div className="mt-4">
          <Button onClick={onClose}>Close</Button>
        </div>
      </div>
    </Modal>
  );
};

export default DataErrorModal;
